/**
 * Who may see the contact page "Subscription detail" (live Zuora Product & Charges and Change History).
 *
 * Owner 2026-11-04: support agents and concierges (concierges are mostly admins) -> exactly these four stored role
 * values. The SERVER enforces the same list (zsub_detail_begin, migration 1670); this only decides whether the panel is
 * drawn, so a role outside the list never sees a button that would be refused.
 */
export const SUBSCRIPTION_DETAIL_ROLES = [
  "superadmin",
  "admin",
  "support_admin",
  "support_agent",
] as const;

export function canViewSubscriptionDetail(
  role: string | null | undefined,
): boolean {
  if (!role) {
    return false;
  }
  // exact stored values; do not strip underscores (support_admin / support_agent)
  return (SUBSCRIPTION_DETAIL_ROLES as readonly string[]).includes(
    role.toLowerCase(),
  );
}
